import { createAsyncThunk } from "@reduxjs/toolkit";
// import { iGenericResponse,REDUCER_NAME ,iAddSuperAdminReachargedListItem} from "./Types";
import { iAddProFormInvoiceDetail ,iGenericResponse,REDUCER_NAME} from "./Types";

import { httpStatusCodes } from "@/customTypes/NetworkTypes";

import { proFormaInvoiceForm } from "@/services/api/cresivoxServer";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);
interface PurchaseOrderPayload {
  vendorId: string;
  amount: string;
}
// addProFormaInvoiceForm
export const addProFormaInvoiceForm = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<any | null> | null,
  PurchaseOrderPayload,
  // @ts-expect-error
  { rejectValue: iStateMessage }
>(
  "addProFormaInvoiceForm",
  async (payload, { rejectWithValue }) => {
    // console.log("dkjbwhfgewhgfuew",payload)
    try {
      // ✅ Call service function instead of axios directly
      const response = await proFormaInvoiceForm.addProFormaInvoiceForm(payload);

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }

          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
 export const getProFormaInvoiceForm = createAsyncThunk<
    // @ts-expect-error
  iGenericResponse<iAddProFormInvoiceDetail | null> | null,
>(
  curriedGetThunkName("getProFormaInvoiceForm"),
  
  async (arg, {rejectWithValue}) => {
    try {
      
      const response = await proFormaInvoiceForm.getProFormaInvoiceForm();
      
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
                // console.log("bfhjgfhegfwegfdghewcdghw",data.data)
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

export const addProFormaDataList = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<any | null> | null,
  PurchaseOrderPayload,
  // @ts-expect-error
  { rejectValue: iStateMessage }
>(
  "addProFormaDataList",
  async (payload, { rejectWithValue }) => {
    // console.log("dkjbwhfgewhgfuew",payload)
    try {
      // ✅ Call service function instead of axios directly
      const response = await proFormaInvoiceForm.addProFormaDataList(payload);

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }

          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

 export const getProFormaDataList = createAsyncThunk<
    // @ts-expect-error
  iGenericResponse<iAddProFormInvoiceDetail | null> | null,
>(
  curriedGetThunkName("getProFormaDataList"),
  
  async (arg, {rejectWithValue}) => {
    try {
      
      const response = await proFormaInvoiceForm.getProFormaDataList();
      
      if (response) {
        const {httpStatusCode, data, message} = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
                // console.log("bfhjgfhegfwegfdghewcdghw",data.data)
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);
